import Sidebar from "../../../components/Navigation/Sidebar";
import Topbar from "../../../components/Navigation/Topbar";
import { HeaderPackaging } from "./components/HeaderPackaging";
import { ContentPackaging } from "./components/ContentPackaging";

const Packaging = () => {
  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <HeaderPackaging />
              <ContentPackaging />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packaging;
